module.exports = __webpack_public_path__ + "static/media/macbook-set-genie-and-iphone-8-availabird-reduced.0feaa255.webp";